import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { WavyContainer } from "react-wavy-transitions";

// *** componentes ***  //
import NavBar from "../Components/Header";
import Footer from "../Components/Footer";

// *** vistas ***  //
import Index from "../Views/Index";
import Nosotros from "../Views/Nosotros";
import Servicios from "../Views/Servicios";
import Portafolio from "../Views/Portafolio";
import Contactos from "../Views/Contactos";
import Terminos from "../Views/Terminos";
import Mensaje from "../Views/Mensaje";

// Servicios
import Ecommerce from "../Views/Servicios/Ecommerce";
import AplicacionMovil from "../Views/Servicios/AplicacionMovil";
import SistemasEmpresariales from "../Views/Servicios/SistemasEmpresariales";
import ADS from "../Views/Servicios/ADS";
import Mantenimiento from "../Views/Servicios/Mantenimiento";
import PaginaWeb from "../Views/Servicios/PaginaWeb";
import Animacion from "../Views/Servicios/Animacion";
import DisenioDigital from "../Views/Servicios/DisenioDigital";

const Routers = () => (
  <BrowserRouter>
    <WavyContainer />
    {window.location.pathname.split("/")[1] === "admin" ? (
      <span></span>
    ) : (
      <NavBar />
    )}
    <Routes>
      {/* vistas */}
      <Route exact path="/" element={<Index />} />
      <Route path="/nosotros" element={<Nosotros />} />
      <Route path="/servicios" element={<Servicios />} />
      <Route path="/portafolio" element={<Portafolio />} />
      <Route path="/terminos-y-condiciones" element={<Terminos />} />
      <Route path="/envio-exitoso" element={<Mensaje />} />

      <Route path="/contacto" element={<Contactos />} />
      {/* servicios */}
      <Route path="/servicio/e-commerce" element={<Ecommerce />} />
      <Route path="/servicio/aplicacion-movil" element={<AplicacionMovil />} />
      <Route
        path="/servicio/sistemas-empresariales"
        element={<SistemasEmpresariales />}
      />
      <Route path="/servicio/google-ads" element={<ADS />} />
      <Route
        path="/servicio/mantenimiento-equipos"
        element={<Mantenimiento />}
      />
      <Route path="/servicio/pagina-web" element={<PaginaWeb />} />
      <Route path="/servicio/animacion" element={<Animacion />} />
      <Route path="/servicio/branding" element={<DisenioDigital />} />
      {/* fin - servicios */}
    </Routes>

    <Footer />
  </BrowserRouter>
);

export default Routers;
